
import type { SagaMount } from "./types";

export const SagaReducer = (state:boolean = false, action: SagaMount) => {

    if (action.type === "SagaMount") {
        return true;
    }
    return state;
}